"use client"
import React, { useEffect, useState } from "react"
import { checkIsSubscribed, isValidEmail } from '@/helpers/ApiCalls/Waitlist';
import { MdClose } from "react-icons/md";
import { Button } from "@nextui-org/react";
export default function FullPageSubscribe({ page }: { page: string }
) {
    const [promoViewed, setPromoViewed] = React.useState(true)
    useEffect(() => {
        if (page === "home" && (localStorage.getItem('homePromoViewed') ? JSON.parse(localStorage.getItem('homePromoViewed') as string).time < Date.now() : true) && localStorage.getItem('promoViewed') !== 'true') {
            setTimeout(() => {
                setPromoViewed(false)
            }, 10000);
        }
        else if (page === "content" && localStorage.getItem('promoViewed') !== 'true') {
            setTimeout(() => {
                setPromoViewed(false)
            }, 5000);
        }
    }, [page])

    const [email, setEmail] = useState("")
    const [isSubscribed, setIsSubscribed] = useState(false)
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState("Subscribe")

    useEffect(() => {
        setIsSubscribed(false)
        setStatus("Subscribe")
    }, [email])

    if (promoViewed) return null
    else
        return (
            <div className="flex items-center justify-center flex-col h-screen w-full bg-[#ffb623be] backdrop-blur-lg z-[120] text-black  fixed top-0 left-0">
                {/* close button on top right corner */}
                <button onClick={() => setPromoViewed(true)} className="absolute top-4 right-4">
                    <MdClose size={36} className="font-bold" />
                </button>
                <div className="flex flex-col items-center justify-center gap-4">
                    <span>Sign up & receive a </span>
                    <h1 className="lg:text-8xl md:text-6xl text-4xl font-black">10% Off</h1>
                    <span>on your first purchase</span>
                    <input type="email" placeholder="Enter your email" className="w-full max-w-[512px] h-12 rounded-md border-2 border-gray-300 p-4" value={email} onChange={(e) => setEmail(e.target.value)} />

                    <Button className={`shadow-2xl hover:bg-[#000000] bg-[#000000] w-full max-w-[512px] h-12 text-white rounded-md`}
                        isLoading={loading}
                        isDisabled={!isValidEmail(email) || isSubscribed}
                        onPress={async () => {
                            await checkIsSubscribed(email, setIsSubscribed, setStatus, setLoading, setPromoViewed);
                        }}>
                        {
                            status
                        }
                    </Button>

                    {
                        isSubscribed ? <span className="text-black">{status === "Already Subscribed" ? "You might have received an email!" : "We'll email you a code shortly!"}</span> : <button onClick={() => {
                            page === "home" ? (
                                () => {
                                    setPromoViewed(true);
                                    localStorage.setItem('homePromoViewed', JSON.stringify({ time: Date.now() + 1000 * 60 * 60 }))
                                }
                            )() :
                                setPromoViewed(true);

                        }} className="text-medium text-gray-800 font-medium hover:text-black">{"No thanks, I don't want a discount"}</button>

                    }
                </div>
            </div>
        )
}